/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sip_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free SIP calculator. Enter your monthly investment, expected return and time period to estimate your mutual fund SIP's future value and returns.`)
};

const es_sip_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de SIP gratuita. Ingresa tu inversión mensual, retorno esperado y período de tiempo para estimar el valor futuro y retornos de tu SIP en fondos mutuales.`)
};

const de_sip_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser SIP-Rechner. Geben Sie Ihre monatliche Investition, erwartete Rendite und Zeitraum ein, um den zukünftigen Wert und die Renditen Ihres Investmentfonds-SIPs zu schätzen.`)
};

const nl_sip_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis SIP-calculator. Voer uw maandelijkse belegging, verwacht rendement en periode in om de toekomstige waarde en rendement van uw SIP in beleggingsfondsen in te schatten.`)
};

const fr_sip_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculatrice SIP gratuite. Entrez votre investissement mensuel, le rendement attendu et la période pour estimer la valeur future et les rendements de votre SIP de fonds commun.`)
};

const it_sip_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore SIP gratuito. Inserisci l'importo mensile investito, il rendimento atteso e il periodo di tempo per stimare il valore futuro e i rendimenti del tuo SIP in fondi comuni.`)
};

const pt_br2_sip_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora SIP gratuita. Digite seu investimento mensal, retorno esperado e período de tempo para estimar o valor futuro e retornos do seu SIP de fundo mútuo.`)
};

const pt_sip_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de SIP gratuita. Introduza o seu investimento mensal, retorno esperado e período de tempo para estimar o valor futuro e os retornos do seu SIP de fundo de investimento.`)
};

const ja_sip_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のSIP計算機。月次投資額、期待利回り、投資期間を入力して、投資信託SIPの将来価値とリターンを推定します。`)
};

const zh_sip_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费SIP计算器。输入您的每月投资、预期收益率和投资期限，估算您的共同基金SIP的未来价值和收益。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sip_hub_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sip_hub_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sip_hub_meta_description", locale)
	if (locale === "en") return en_sip_hub_meta_description(inputs)
	if (locale === "es") return es_sip_hub_meta_description(inputs)
	if (locale === "de") return de_sip_hub_meta_description(inputs)
	if (locale === "nl") return nl_sip_hub_meta_description(inputs)
	if (locale === "fr") return fr_sip_hub_meta_description(inputs)
	if (locale === "it") return it_sip_hub_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_sip_hub_meta_description(inputs)
	if (locale === "pt") return pt_sip_hub_meta_description(inputs)
	if (locale === "ja") return ja_sip_hub_meta_description(inputs)
	return zh_sip_hub_meta_description(inputs)
};